export const PARAMS = [
  {
    key: "windSpeed",
    label: "Vitesse du vent",
    unit: "km/h",
    min: 0,
    max: 100,
    step: 0.1, 
    color: "#e53935",
  },
  {
    key: "windDirection",
    label: "Direction du vent",
    unit: "°",
    min: 0,
    max: 360,
    step: 1, 
    color: "#e57c00",
  },
  {
    key: "fuelMoisture",
    label: "Humidité du combustible",
    unit: "%",
    min: 1,
    max: 40,
    step: 0.1, 
    color: "#0288d1",
  },
  {
    key: "temperature",
    label: "Température",
    unit: "°C",
    min: -20,
    max: 60,
    step: 0.1, 
    color: "#2b9e07",
  },
];